import React, { PureComponent } from "react";

import { Select } from "../../components";
import GoogleMapView from "./GoogleMapView";

import style from "./MapView.module.scss";

// `data` is a flat array of project.location components straight from
// Strapi ({label, year, area, lat, lng, address, ...} — lat/lng numeric,
// no more city grouping or "lat,lng" string that the old CMS shape had).
class MapView extends PureComponent {
  constructor(props) {
    super(props);
    this.state = this._stateFor(props.data);
  }

  _stateFor(data) {
    const first = (data && data[0]) || null;
    return {
      details: first,
      latitude: first ? first.lat : '',
      longitude: first ? first.lng : '',
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.setState(this._stateFor(this.props.data));
    }
  }

  _handleChange = e => {
    this.setState({
      details: e,
      latitude: e.lat,
      longitude: e.lng,
    })
  }

  render() {
    const { details, longitude, latitude } = this.state;
    const { data, glossary } = this.props;
    // react-select (used by <Select>) needs a `.value` per option.
    const options = data.map(loc => ({ ...loc, value: `${loc.lat},${loc.lng}` }));

    return (
      <div className={style.container}>
        <div className={style.line__separator} />
        <div className={style.map__title}>{glossary.location}</div>
        <Select data={options} onChange={this._handleChange} glossary={glossary}/>
        <div className={style.map__container}>
          {details && (
            <GoogleMapView
              latitude={latitude}
              longitude={longitude}
              data={details}
            />
          )}
        </div>
      </div>
    )
  }
}

export default MapView;